import { render, staticRenderFns } from "./UploadChunkFile.vue?vue&type=template&id=28f03810&scoped=true"
import script from "./UploadChunkFile.vue?vue&type=script&lang=js"
export * from "./UploadChunkFile.vue?vue&type=script&lang=js"
import style0 from "./UploadChunkFile.vue?vue&type=style&index=0&id=28f03810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f03810",
  null
  
)

export default component.exports